"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var App_1 = require("../../App");
var ImpressionTracker_1 = __importDefault(require("../Tracking/ImpressionTracker/ImpressionTracker"));
var VerifyAccountTracking_1 = require("../VerifyAccountTracking");
var BlockedUserTracking = function (props) {
    var state = React.useContext(App_1.RiskContext).state;
    return (React.createElement(ImpressionTracker_1["default"], { onImpression: function () { return VerifyAccountTracking_1.trackOnBlockedPageTrigger(state.workflow); } },
        React.createElement("div", null, props.children(function () { return VerifyAccountTracking_1.trackOnBlockedPageHelp(state.workflow); }))));
};
exports["default"] = BlockedUserTracking;
